import { useBreakpointValue } from '@chakra-ui/react';
import { Flex } from 'src/components/UI/Flex';
import { Button } from 'src/components/UI/Button';
import { Box } from 'src/components/UI/Box';
import ArrowIcon from 'src/components/Icons/ArrowIcon';

interface NavigationButtonsProps {
  onBack?: () => void;
  onNext: () => void;
  nextLabel?: string;
  isLoading?: boolean;
  showBackButton?: boolean;
}

export function NavigationButtons({
  onBack,
  onNext,
  nextLabel = 'Próximo',
  isLoading = false,
  showBackButton = true,
}: NavigationButtonsProps) {
  const isMobile = useBreakpointValue({ base: true, lg: false }, { ssr: false });
  return (
    <Flex
      position={isMobile ? 'fixed' : 'absolute'}
      pointerEvents={'none'}
      bottom={0}
      paddingBottom={isMobile ? '20px' : '0'}
      background={'linear-gradient(to bottom, rgba(255, 255, 255, -2.5),  rgba(255, 255, 255, 4.5))'}
      left="0"
      right="0"
      px={isMobile ? '20px' : '0'}
      zIndex="998"
      justifyContent="space-between"
      mt="auto"
      pt="24px"
      flexShrink={0}
      flexDir={{ base: 'column', sm: 'row' }}
      gap={{ base: '12px', sm: '0' }}
      flexDirection={isMobile ? 'row-reverse' : 'column'}
    >
      {showBackButton && onBack && (
        <Button
          pointerEvents={'all'}
          h={isMobile ? '60px' : '44px'}
          w={isMobile ? '60px' : 'auto'}
          px="20px"
          fontSize="14px"
          variant="outline"
          borderColor={isMobile ? 'gray.700' : 'primary.900'}
          bg={isMobile ? 'gray.700' : 'white'}
          color="primary.900"
          onClick={onBack}
          order={{ base: 2, sm: 1 }}
          leftIcon={
            !isMobile ? (
              <Box
                w="24px"
                h="24px"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="primary.900"
              >
                <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M10 12L6 8L10 4"
                    stroke="#4A5568"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Box>
            ) : undefined
          }
          _hover={{ bg: 'gray.50', borderColor: 'gray.400' }}
        >
          {isMobile ? <ArrowIcon direction="left" width={10} variantColor="white" /> : 'Voltar'}
        </Button>
      )}

      <Button
        pointerEvents={'all'}
        h={isMobile ? '60px' : '44px'}
        w={isMobile ? '60px' : 'auto'}
        borderRadius="full"
        px="20px"
        fontSize="14px"
        variant="solid"
        colorScheme="primary"
        onClick={onNext}
        isLoading={isLoading}
        order={{ base: 1, sm: 2 }}
        ml={!showBackButton || !onBack ? 'auto' : 0}
        rightIcon={
          !isMobile ? (
            <Box
              w="24px"
              h="24px"
              borderRadius="full"
              bg="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
              ml="8px"
            >
              <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                <path
                  d="M6 12L10 8L6 4"
                  stroke="#7C3AED"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          ) : undefined
        }
      >
        {isMobile ? <ArrowIcon direction="right" width={10} variantColor="white" /> : nextLabel}
      </Button>
    </Flex>
  );
}
